import { render, staticRenderFns } from "./EnableConformity.vue?vue&type=template&id=f5e21e7a&scoped=true&"
import script from "./EnableConformity.vue?vue&type=script&lang=js&"
export * from "./EnableConformity.vue?vue&type=script&lang=js&"
import style0 from "./EnableConformity.vue?vue&type=style&index=0&id=f5e21e7a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5e21e7a",
  null
  
)

export default component.exports